module.exports = __webpack_public_path__ + "img/joven.434fd8da.png";